import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "./styles/tokens.css";
import "./styles/inner-page.css";
import "./styles/home-dimension.css";
import "./styles/site-v2.css";
import "./styles/case-study-inner.css";
import "./styles/process-infographic.css";
import "./styles/inner-infographic.css";
import "./styles/page-ai-section.css";
import "./components/LazyPageShell/lazyPageShell.css";

import "./assets/themify-icon/themify-icons.css";
import "./assets/simple-line-icon/simple-line-icons.css";
import "./assets/font-awesome/css/all.css";
import "./assets/elagent/style.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./assets/animate.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/main.css";
import "./assets/responsive.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "popper.js";
import "./assets/simple-line-icon/fonts/CodeNext-ExtraBold.ttf";
import "./assets/simple-line-icon/fonts/CodeNext-Trial-ExtraBold.ttf";

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);
root.render(<App />);

serviceWorker.unregister();
